import { render } from "./NLSFooter.vue?vue&type=template&id=3d9cb030&scoped=true"
import script from "./NLSFooter.vue?vue&type=script&lang=js"
export * from "./NLSFooter.vue?vue&type=script&lang=js"

import "./NLSFooter.vue?vue&type=style&index=0&id=3d9cb030&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/aws.total-account-site.US/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d9cb030"]])

export default __exports__